import procedimentoRepository from './procedimentoRepository'
import exportacaoRepository from './exportacaoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/apac`

    return {
        procedimento: procedimentoRepository(baseUrl),
        exportacao: exportacaoRepository(baseUrl),
    }
}
